<template lang="pug">
  .edit-product-item-weight
    v-card(flat)
      v-row(no-gutters)
        v-col.py-1.shrink
          v-img.ma-2(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" width="88px" aspect-ratio="1")
        v-col.py-3.pr-2
          v-row(no-gutters)
            v-col
              div.p1.basic800--text.mb-1(style="word-break: break-word;") {{ product.display_name }}
              div.c1.basic600--text.product-description.mb-1(v-html="product.description")
            v-col.shrink(align="center")
              div.ml-2(style="width: 65px")
                p.mb-1.label.basic600--text.text-uppercase {{ $t('in_stock') }}
                v-text-field.centered-input(v-model.number="quantity" outlined dense hide-details type="number" :class="{ 'qtyChanged': (quantity != product.inventory_qty && quantity>=0) || (focused && quantity>=0)}" placeholder="0" background-color="basic200" height="40" min="0" :rules="rules.number_not_empty" :readonly="member.role !== 'Admin'")
                .align-self-center.c1.danger500--text.mt-1(v-if="quantity < 0 || quantity === ''")| Min. 0
          v-row(no-gutters align="center" :class="parentProductId ? 'mt-2' : ''")
            v-col
              div.c2.basic600--text {{ product.price | displayPrice }}
            v-col.shrink(v-if="parentProductId")
              v-btn.px-1.text-none(class="button-Aa-tiny custom-transform-class" text x-small color="textColorAccent" @click="goToParentProduct()") {{ product.variant_for ? $t('view_all_variants') : $t('view_all_addons') }}

</template>

<script>
import { mapState } from 'vuex'
import ShowMoreText from '@/components/ShowMoreText.vue'
export default {
  name: 'EditProductItemQuantity',
  props: ['product', 'pid','edited','focused'],
  components: { ShowMoreText },
  data: (v) => ({
    parentProduct: null,
    quantity: v.product.inventory_qty,
    rules: {
      number_not_empty: [
        v => v !== null || 'This field is required',
        v => v !== '' || 'This field is required'
      ]
    }
  }),
  mounted(){
    if (this.edited) {
      this.quantity = this.edited.quantity
    }
  },
  watch: {
    quantity (val) {
      this.$emit('editQuantity', {id: this.product.id, quantity: val==this.product.inventory_qty ? null : val})
    }
  },
  computed: {
    ...mapState('user', ['member']),
    parentProductId () {
      if (this.pid) {
        return null
      }
      return this.product.variant_for || this.product.addon_for
    }
  },
  methods: {
    goToParentProduct() {
      this.$router.push(`/admin/products-inventory/${this.parentProductId}`)
    },
  }
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center
}
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
.clickable {
  cursor: pointer;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.qtyChanged{
  border: 1px solid var(--v-success500);
}
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; 
  overflow: hidden;
  word-break: break-word;
}
</style>